import { createStore, applyMiddleware } from "redux";
import rootReducer from "./reducers";
import thunk from "redux-thunk";
import { composeWithDevTools } from "redux-devtools-extension";
import toastMiddleware from "./middleware/toastMiddleware";

const enhancerList = [applyMiddleware(thunk, toastMiddleware)];

const store = createStore(rootReducer, composeWithDevTools(...enhancerList));

export default store;
